import { render, staticRenderFns } from "./customer_merge.vue?vue&type=template&id=25fbc618&scoped=true&"
import script from "./customer_merge.vue?vue&type=script&lang=js&"
export * from "./customer_merge.vue?vue&type=script&lang=js&"
import style0 from "./customer_merge.vue?vue&type=style&index=0&id=25fbc618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fbc618",
  null
  
)

export default component.exports